/* Promo bar — only paints while the offer is live. Mirror in Liquid. */
(function(){
  var bar = document.querySelector('.promo');
  if(!bar) return;
  var ends = new Date(bar.dataset.endsAt).getTime();
  if(!ends || isNaN(ends) || Date.now() >= ends){
    bar.hidden = true;
    return;
  }
  bar.hidden = false;
  var out = {
    days: bar.querySelector('[data-countdown="days"]'),
    hours: bar.querySelector('[data-countdown="hours"]'),
    minutes: bar.querySelector('[data-countdown="minutes"]'),
    seconds: bar.querySelector('[data-countdown="seconds"]')
  };
  (function tick(){
    var left = ends - Date.now();
    if(left <= 0){
      bar.hidden = true;
      return;
    }
    var s = Math.floor(left/1000);
    var d = Math.floor(s/86400);
    var h = Math.floor((s%86400)/3600);
    var m = Math.floor((s%3600)/60);
    var sec = s%60;
    if(out.days) out.days.textContent = String(d).padStart(2,'0');
    if(out.hours) out.hours.textContent = String(h).padStart(2,'0');
    if(out.minutes) out.minutes.textContent = String(m).padStart(2,'0');
    if(out.seconds) out.seconds.textContent = String(sec).padStart(2,'0');
    setTimeout(tick, 1000);
  })();
})();

/* Cart count from /cart.js */
(function(){
  var els = document.querySelectorAll('[data-cart-count]');
  if(!els.length) return;
  fetch('/cart.js')
    .then(function(r){ return r.ok ? r.json() : null; })
    .then(function(cart){
      if(!cart || typeof cart.item_count === 'undefined') return;
      var n = String(cart.item_count);
      els.forEach(function(el){
        el.textContent = n;
        el.classList.toggle('is-zero', cart.item_count === 0);
      });
    })
    .catch(function(){});
})();

/* Dialogs — native <dialog> handles focus trapping and Esc for free. */
document.querySelectorAll('dialog.drawer').forEach(function(d){
  if(!d.open){
    d.removeAttribute('open');
    d.style.display = 'none';
  }
});
document.querySelectorAll('[aria-controls]').forEach(function(btn){
  var t = document.getElementById(btn.getAttribute('aria-controls'));
  if(!t || t.tagName !== 'DIALOG') return;
  btn.addEventListener('click', function(){
    t.style.display = '';
    t.showModal();
    btn.setAttribute('aria-expanded','true');
  });
  t.addEventListener('close', function(){
    btn.setAttribute('aria-expanded','false');
    t.style.display = 'none';
  });
});
document.querySelectorAll('[data-close-dialog]').forEach(function(b){
  b.addEventListener('click', function(){ b.closest('dialog').close(); });
});

/* Gallery */
(function(){
  var main = document.getElementById('gallery-main');
  if(!main) return;
  var stage = document.querySelector('[data-gallery-stage]');
  var btns = document.querySelectorAll('.gallery__thumbs button');
  btns.forEach(function(btn){
    btn.addEventListener('click', function(){
      btns.forEach(function(b){ b.removeAttribute('aria-current'); });
      btn.setAttribute('aria-current','true');
      if(btn.dataset.full) main.src = btn.dataset.full;
      var thumb = btn.querySelector('img');
      if(thumb) main.alt = thumb.alt || '';
      if(stage){
        if(btn.dataset.collage === 'true') stage.classList.add('is-collage');
        else stage.classList.remove('is-collage');
      }
    });
  });
})();

/* Buy box: keep variant + selling plan inputs in sync before add-to-cart */
(function(){
  var box = document.getElementById('custom_buy_box');
  var form = box ? box.querySelector('[data-lh-buy-form], form') : document.querySelector('.buy form[action*="/cart/add"]');
  if(!form) return;

  var variantInput = form.querySelector('#lh-buy-variant') || form.querySelector('input[name="id"]');
  var planInput = form.querySelector('#lh-buy-selling-plan');

  function syncVariant(){
    if(!variantInput) return;
    var checked = form.querySelector('input[name="bundle"]:checked');
    if(checked && checked.dataset.variantId){
      variantInput.value = checked.dataset.variantId;
      variantInput.setAttribute('name', 'id');
    }
  }

  function ensurePlanInput(){
    if(planInput) return planInput;
    planInput = document.createElement('input');
    planInput.type = 'hidden';
    planInput.id = 'lh-buy-selling-plan';
    form.appendChild(planInput);
    return planInput;
  }

  function syncPlan(){
    var checked = form.querySelector('input[name="purchase_option"]:checked');
    var input = ensurePlanInput();
    if(!checked){
      input.removeAttribute('name');
      input.value = '';
      return;
    }
    var v = String(checked.value || '');
    if(v === 'onetime' || v === '' || v === 'subscription'){
      input.removeAttribute('name');
      input.value = '';
    } else if(/^\d+$/.test(v)){
      input.setAttribute('name', 'selling_plan');
      input.value = v;
    } else {
      input.removeAttribute('name');
      input.value = '';
    }
  }

  form.querySelectorAll('input[name="bundle"]').forEach(function(r){
    r.addEventListener('change', syncVariant);
  });
  form.querySelectorAll('input[name="purchase_option"]').forEach(function(r){
    r.addEventListener('change', syncPlan);
  });

  form.addEventListener('submit', function(){
    syncVariant();
    syncPlan();
  });

  syncVariant();
  syncPlan();
})();

/* Reviews toggle with announced state. */
(function(){
  var btn = document.querySelector('.reviews__more');
  var list = document.getElementById('reviews-list');
  if(!btn || !list) return;
  btn.addEventListener('click', function(){
    var open = list.classList.toggle('is-expanded');
    btn.setAttribute('aria-expanded', String(open));
    btn.textContent = open
      ? (btn.getAttribute('data-label-less') || 'Show Less')
      : (btn.getAttribute('data-label-more') || 'Show More');
  });
})();

/* Anchor CTAs move focus, not just scroll — this is why #custom_buy_box
   carries tabindex="-1". */
document.querySelectorAll('a[href^="#"]:not(.skip-link)').forEach(function(a){
  a.addEventListener('click', function(){
    var t = document.querySelector(a.getAttribute('href'));
    if(t) t.focus({preventScroll:true});
  });
});
